<template>
	<div class="home_page">
		<div class="banner">
			<el-carousel trigger="click" height="288px" style="width: 100%">
				<el-carousel-item v-for="item in banners" :key="item.id">
					<img :src="url + item.imageUrl" height="100%" width="100%" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="page_wrapper">
			<div class="mod_menu">
				<ul class="menu_list">
					<li v-for="(v, i) in yqType" :key="i" @click="$router.push({ name: 'allequpt', query: { code: v.code } })">
						<img width="48" height="48" :src="url + v.icon" />
						<span>{{ v.val }}</span>
					</li>
					<li @click="$router.push({ name: 'allequpt' })">
						<img width="48" height="48" src="@/assets/img/home_all.png" />
						<span>全部设备</span>
					</li>
				</ul>
			</div>
			<div class="square">
				<div class="square_news">
					<div class="square_title">
						<span class="name">公司概况</span>
						<!-- <span class="more" @click="$router.push({ name: 'centerNews' })">更多</span> -->
					</div>
					<div class="square_main">
						<div v-html="centerContent" style="height: 378px;overflow:auto;"></div>
						<!-- <div class="left"> -->
							<!-- <div class="big_img" v-if="newsList.length" @click="$router.push({ name: 'newsDetails', query: { id: newsList[0].id } })">
								<img :src="filePreview + newsList[0].imageUrl" alt="" />
								<div>{{ newsList[0].title }}</div>
							</div> -->
							<!-- <div class="img_list">
								<img v-if="newsList.length > 1" @click="$router.push({ name: 'newsDetails', query: { id: newsList[1].id } })" :src="filePreview + newsList[1].imageUrl" alt="" />
								<img
									v-if="newsList.length > 2"
									@click="$router.push({ name: 'newsDetails', query: { id: newsList[2].id } })"
									style="margin: 0 6px"
									:src="filePreview + newsList[2].imageUrl"
									alt=""
								/>
								<img v-if="newsList.length > 3" @click="$router.push({ name: 'newsDetails', query: { id: newsList[3].id } })" :src="filePreview + newsList[3].imageUrl" alt="" />
							</div> -->
						<!-- </div> -->
						<!-- <div class="right"> -->
							<!-- <div class="tuijian" v-if="newsList.length > 4" @click="$router.push({ name: 'newsDetails', query: { id: newsList[4].id } })">
								<dl>
									<dt><img :src="filePreview + newsList[4].imageUrl" alt="" class="newsImg" /></dt>
									<dd>
										<h3 class="newsTitle">{{ newsList[4].title }}</h3>
										<p class="introduction">与此同时，集团公司各下属单位的双创工作也在稳步开展，并取得了不俗成绩，建设有煤炭科技孵。</p>
										<span class="time"> {{ newsList[4].releaseTime | formatDateSplitYm }}-{{ newsList[4].releaseTime | formatDateSplitD }}</span>
									</dd>
								</dl>
							</div> -->
							<!-- <div class="newsList">
								<div class="newsitem" v-for="(v, i) in newsList.slice(1, 5)" :key="i" @click="$router.push({ name: 'newsDetails', query: { id: v.id } })">
									<div class="ltime">
										<span class="day">{{ v.releaseTime | formatDateSplitD }}</span>
										<span class="ym">{{ v.releaseTime | formatDateSplitYm }}</span>
									</div>
									<div class="text ellipsis" style="width: 366px">{{ v.title }}</div>
								</div>
							</div> -->
						<!-- </div> -->
					</div>
				</div>
				<div class="square_child">
					<div class="square_notice">
						<div class="square_title">
							<span class="name">通知公告</span>
							<span class="more" @click="$router.push({ name: 'broadcast' })">更多</span>
						</div>
						<div class="square_main">
							<ul class="notice_list" v-loading="tgLoading">
								<li v-for="(v, i) in tgList" :key="i" @click="$router.push({ name: 'broadDetails', query: { id: v.id } })">
									<span class="dotted"></span>
									<span class="text">{{ v.title }}</span>
									<span class="time">{{ v.releaseTime | formatDate }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="square_quick">
						<div class="square_title">
							<span class="name">快捷通道</span>
						</div>
						<div class="square_main">
							<ul>
								<li @click="$router.push({ name: 'allequpt', query: { routeName: 'wtsj' } })">
									<img src="@/assets/img/f001.png" alt="" />
									<span>委托送检</span>
								</li>
								<li @click="$router.push({ name: 'demand' })">
									<img src="@/assets/img/f002.png" alt="" />
									<span>技术服务</span>
								</li>
								<li @click="surveyHandle()">
									<img src="@/assets/img/f003.png" alt="" />
									<span>意见建议</span>
								</li>
								<li @click="$router.push({ name: 'userguide' })">
									<img src="@/assets/img/f004.png" alt="" />
									<span>用户指南</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="square">
				<div class="square_prod">
					<div class="square_title">
						<span class="name">仪器设备</span>
						<span class="more" @click="$router.push({ name: 'allequpt' })">更多</span>
					</div>
					<div class="square_main" v-loading="sbListLoading">
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div
									class="prodItem swiper-slide"
									style="width: 276px !important; flex-shrink: 0"
									v-for="(item, index) of sbList"
									:key="index"
									@click="$router.push({ name: 'devicedetail', query: { prn: item.prn, routeName: 'home' } })"
								>
									<img width="276" height="168" :src="url + item.goodsImage[0]" style="margin-right: 10px; width: 276px" />
									<p class="ellipsis eqName">{{ item.goodsName }}</p>
								</div>
							</div>
							<div class="swiper-button-prev rot" slot="button-prev">
								<div class="pre-btn">
									<i class="el-icon-back"></i>
								</div>
							</div>
							<div class="swiper-button-next rat" slot="button-next">
								<div class="pre-btn">
									<i class="el-icon-right"></i>
								</div>
							</div>
							<!-- <div class="swiper-button-next"></div> -->
							<!-- <div class="swiper-button-prev"></div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { formatdate } from '@/utils/index'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
export default {
	data() {
		return {
			timer: null,
			theSpeed: 2,
			imgWidth: 260,
			theDirection: 'left',
			url: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/preview/',
			banners: [],
			yqType: [],
			tgLoading: false,
			tgList: [],
			newsLoading: false,
			newsList: [],
			sbListLoading: false,
			sbList: [],
			centerContent:''
		}
	},
	filters: {
		formatDateSplitD(time) {
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd').slice(8)
		},
		formatDateSplitYm(time) {
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd').slice(0, 7)
		},
		formatDate(time) {
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd hh:mm:ss')
		},
	},
	computed: {
		surveyVisible: {
			get() {
				return this.$store.state.surveyVisible
			},
			set(val) {
				this.$store.commit('updateSurveyVisible', val)
			},
		},
		filePreview() {
			return window.SITE_CONFIG.previewFile
		},
	},
	created() {
		this.getBanner()
		this.getyqType()
		this.getNews()
		this.getTg()
		this.getSbList()
		this.getCenterContent()
	},
	methods: {
		getCenterContent(){
			this.$http.get(this.$api.systemApi.ZxDetail).then(({ data }) => {
        this.centerContent = data.data.content;
      }).catch(()=>{
        this.centerContent = '';
      });
		},
		initSwiper() {
			this.$nextTick(() => {
				new Swiper('.swiper-container', {
					slidesPerView: 4,
					spaceBetween: 20,
					// centeredSlides: true,
					loop: true,
					// autoplay: {
					// 	// 每秒钟自动切换
					// 	// delay: 3000,
					// 	// 用户操作swiper之后，是否禁止autoplay
					// 	disableOnInteraction: false,
					// },
					// 如果需要前进后退按钮
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
						hideOnClick: true,
					},
					preventLinksPropagation: false, // 阻止点击事件冒泡
					observeParents: true, //修改swiper自己或子元素时，自动初始化swiper
					observer: true, //修改swiper的父元素时，自动初始化swiper
					disableOnInteraction: false,
				})
			})
		},
		getSbList() {
			this.sbListLoading = true
			let params = {
				current: 1,
				size: 1000000,
				data: {
					st: 1,
				},
			}
			this.$http
				.post(this.$api.goodsApi.goodsList, params)
				.then(({ data }) => {
					this.sbListLoading = false
					this.sbList = data.data.list
					this.$nextTick(() => {
						this.initSwiper()
					})
				})
				.catch(() => {
					this.sbListLoading = false
				})
		},
		getNews() {
			this.newsLoading = true
			this.$http
				.post(this.$api.systemApi.news, {
					current: 1,
					size: 10,
					data: {
						type: 'XWZX',
					},
				})
				.then(({ data }) => {
					this.newsLoading = false
					this.newsList = data.data.list || []
				})
				.catch(() => {
					this.newsLoading = false
					this.newsList = []
				})
		},
		getTg() {
			this.tgLoading = true
			this.$http
				.post(this.$api.systemApi.news, {
					current: 1,
					size: 6,
					data: {
						type: 'TZGG',
					},
				})
				.then(({ data }) => {
					this.tgLoading = false
					this.tgList = data.data.list || []
				})
				.catch(() => {
					this.tgLoading = false
					this.tgList = []
				})
		},
		getyqType() {
			this.$http.get(this.$api.dicApi.getDicList, { params: { code: 'SBFL' } }).then(({ data }) => {
				this.yqType = data.data
			})
		},
		getBanner() {
			this.$http
				.get(this.$api.systemApi.banners + '?type=BANNER_SY')
				.then(({ data }) => {
					this.banners = data.data
				})
				.catch(() => {
					this.banners = []
				})
		},
		surveyHandle() {
			let token = this.$cookie.get('X-Web-Token')
			if (!token) {
				this.$message({
					message: '请先登录系统！',
					type: 'warning',
				})
			} else {
				this.surveyVisible = true
			}
		},
	},
}
</script>
<style>
.swiper-slide {
	width: 276px !important;
}
.swiper-container {
	--swiper-navigation-size: 0;
}
.swiper-button-prev {
	left: 2px;
}
.swiper-button-next {
	right: 2px;
}
</style>

<style lang="scss" scoped>
.home_page {
	.banner {
		display: flex;

		img {
			display: block;
			flex: 1;
		}
	}

	.mod_menu {
		background: #fff;
		padding: 30px 40px;
		border-radius: 16px;
		margin-top: 15px;

		.menu_list {
			display: flex;
			align-items: center;
			justify-content: space-between;

			li {
				display: flex;
				flex-direction: column;
				align-items: center;
				cursor: pointer;

				&:hover {
					opacity: 0.8;
				}

				img {
					display: block;
					width: 48px;
					height: 48px;
					margin-bottom: 5px;
				}
			}
		}
	}

	.square {
		display: flex;

		margin-top: 16px;

		.square_title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 14px 20px;
			border-bottom: 1px solid #dcdcdc63;

			.name {
				color: #2962b0;
				display: inline-block;
				border-left: 3px solid #2962b0;
				padding-left: 10px;
				line-height: 15px;
				font-size: 16px;
				font-weight: bold;
			}
		}

		.square_news {
			flex: 1;
			margin-right: 16px;
			background: #fff;
			border-radius: 16px;

			.square_main {
				display: flex;
				padding: 24px 20px;

				.left {
					display: flex;
					flex-direction: column;

					.big_img {
						margin-bottom: 12px;
						position: relative;
						top: 0;
						left: 0;
						img {
							width: 342px;
							height: 300px;
							border-radius: 10px;
						}
						div {
							position: absolute;
							bottom: 0px;
							left: 0px;
							color: #fff;
							padding: 8px 10px;
							box-sizing: border-box;
							// background: rgba(0, 0, 0, 0.5);
							background-image: linear-gradient(-180deg, transparent, rgba(0, 0, 0, 0.65) 97%);
							width: 100%;
							cursor: default;
							border-radius: 0 0 10px 10px;
						}
					}

					.img_list {
						img {
							width: 110px;
							height: 110px;
						}
					}
				}

				.right {
					flex: 1;
					margin-left: 16px;

					.tuijian {
						cursor: pointer;
						dl {
							display: flex;
							align-items: flex-start;

							dt {
								margin-right: 15px;

								img {
									display: block;
								}
							}

							dd {
								h3,
								p {
									padding: 0;
									margin: 0;
								}

								h3 {
									margin-bottom: 7px;
									color: #3e3a39;
								}

								p {
									line-height: 23px;
								}

								.time {
									font-size: 12px;
									color: #999999;
								}
							}
						}
					}

					.newsitem {
						display: flex;
						align-items: center;
						margin-top: 20px;
						background: #f7f7f7;
						cursor: pointer;

						.ltime {
							display: flex;
							flex-direction: column;
							align-items: center;
							background: #fff;
							padding-right: 15px;

							.day {
								font-size: 26px;
								font-weight: bold;
								color: #999999;
							}

							.ym {
								font-size: 12px;
								color: #999999;
								padding: 4px 0;
							}
						}

						.text {
							flex: 1;
							padding-left: 15px;
							border-radius: 10px;
						}
					}
				}
			}
		}

		.square_child {
			display: flex;
			flex-direction: column;
			width: 30%;
		}

		.square_notice {
			flex: 1;
			background: #fff;
			margin-bottom: 16px;
			border-radius: 16px;

			.square_main {
				padding: 24px 20px;
			}

			.notice_list {
				li {
					display: flex;
					align-items: baseline;
					margin-bottom: 12px;
					cursor: pointer;

					.dotted::before {
						content: '';
						display: inline-block;
						border: 3px solid #d1d1d1;
						vertical-align: 2px;
						margin-right: 15px;
						border-radius: 5px;
					}

					.text {
						flex: 1;
						color: #3e3a39;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;

						&:hover {
							color: #2962b0;
							opacity: 0.9;
						}
					}

					.time {
						font-size: 12px;
						color: #999999;
					}
				}
			}
		}

		.square_quick {
			background: #fff;
			border-radius: 16px;

			.square_main {
				padding: 24px 20px;
			}

			ul {
				display: flex;
				align-items: center;
				justify-content: space-between;

				li {
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					&:hover {
						opacity: 0.8;
					}

					img {
						margin-bottom: 8px;
					}
				}
			}
		}

		.square_prod {
			flex: 1;
			width: 100%;
			background: #fff;
			border-radius: 16px;
			margin-bottom: 60px;

			.square_main {
				display: flex;
				height: 200px;
				padding: 16px 20px;

				.swiper-container {
					width: 100%;
					overflow: hidden;

					.swiper-slide {
						width: 276px;
					}

					.prodItem {
						position: relative;
						cursor: grab;
						width: 276px;
						margin-right: 20px;
						img {
							border-radius: 16px;
						}
					}
				}
			}
		}
	}
}

.more {
	cursor: pointer;
}

.newsImg {
	width: 100px;
}

.eqName {
	line-height: 21px;
	font-size: 15px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #fff;
	position: absolute;
	left: 0;
	bottom: -15px;
	width: 100%;
	height: 40px;
	box-sizing: border-box;
	padding: 10px 10px 0 10px;
	border-radius: 0 0 16px 16px;
	background-image: linear-gradient(-180deg, transparent, rgba(0, 0, 0, 0.65) 97%);
	text-align: center;
}
.pre-btn {
	width: 45px;
	height: 45px;
	border-radius: 50%;
	background: #f0f0f0;
	color: #2962b0;
	font-size: 24px;
	font-weight: bold;
	text-align: center;
	line-height: 45px;
	// background-color: rgba(0, 0, 0, 0.1);
}
.pre-btn:hover {
	background: #2962b0;
	color: #fff;
}
</style>
